import { callLogging } from './callLogging';
export const clickContinue = (pageName, url) => {
  callLogging(pageName, url);
};
